module.exports = __webpack_public_path__ + "img/web_ncyu_1.0e33c1ed.jpg";